import Navbar from "../../components/UI/Navbar/navbar";
// import Sidebar from "../../components/UI/Sidebar/sidebar";

import DataVelocity from "../../pages/Data";
// import Control from "../../pages/Control";
import Graph from "../../pages/Graph/Graph";
import ThreeD from "../../pages/ThreeD";
import DataTemperature from "../../pages/DataTemp";
import ControlSlider from "../../pages/controlSlider";
// import Linerss from "../../pages/Graph/zzGraph";

import "bootstrap/dist/css/bootstrap.min.css";
import AngularVelocity from "../../pages/Angular Velocity/angularVelocity";

import React, { useState, useEffect } from "react";

const Layout = () => {
  const [SliderValue, setSlider] = useState(30);
  const [Satdata, setSatdata] = useState({
    temperature: 0,
    humidity: 0,
    velocity: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      fetch("/data")
        .then((response) => response.json())
        .then((data) => {
          return {
            temperature: data.temperature,
            humidity: data.humidity,
            velocity: data.velocity,
          };
        })
        .then(setSatdata)
        .catch(function (error) {
          console.log(error);
        });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const addSlider = () => {
    let newValue = SliderValue < 360 ? SliderValue + 5 : 360;
    setSlider(newValue);
  };
  const subtractSlider = () => {
    let newValue = SliderValue > 0 ? SliderValue - 5 : 0;
    setSlider(newValue);
  };
  let centere = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <React.Fragment>
      <Navbar />
      <div>
        <div style={{ height: "40px" }}></div>
        <div className="row" style={{ height: "240px" }}>
          <div className="col-lg-9 col-md-7 col-sm-12">
            <div className="row">
              <div className="col-3" style={{ marginTop: "100px" }}>
                {" "}
                <DataTemperature temperature={Satdata.temperature} />
              </div>
              <div className="col-9">
                {" "}
                <Graph style={centere} velocity={Satdata.velocity} />
              </div>
            </div>

            <div
              className="row"
              style={{ marginTop: "120px", height: "200px" }}
            >
              <div
                className="col-lg-4 col-md-12 col-sm-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DataVelocity humidity={Satdata.humidity} />
              </div>
              <div className="col-lg-5 col-md-12 col-sm-12">
                <ControlSlider
                  sliderValue={SliderValue}
                  addSlider={addSlider}
                  subtractSlider={subtractSlider}
                />
              </div>
              <div
                className="col-lg-3 col-md-12 col-sm-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AngularVelocity />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-5 col-sm-12 m-auto">
            <ThreeD angle={SliderValue} />
            {/* <Linerss /> */}
          </div>
        </div>

        {/* ------------ ---------------- */}
        {/* <div className="row">
          <div className="col-lg-8 col-md-7 col-sm-12">
            <ControlSlider
              sliderValue={SliderValue}
              addSlider={addSlider}
              subtractSlider={subtractSlider}
            />
          </div>
          <div className="col-lg-4 col-md-5 col-sm-12"></div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default Layout;
